module.exports = __webpack_public_path__ + "static/media/atom-logo-swish-horizontal.c5808479.png";